export default __webpack_public_path__ + "static/media/enghien03.85b251d1.jpg";